import { Close } from '@mui/icons-material';
import { Box, IconButton, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Gallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

interface Image {
  original: string;
  thumbnail: string;
  description: string;
}

interface ImageGalleryModalProps {
  open: boolean;
  onClose: () => void;
  images: Image[];
  startIndex?: number;
}

const ImageGalleryModal: React.FC<ImageGalleryModalProps> = ({ open, onClose, images, startIndex }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    if (open) window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  const handleScreenChange = (isFullscreen: boolean) => {
    setIsFullscreen(isFullscreen);
  };

  return (
    <Modal open={open} onClose={onClose} disableEscapeKeyDown={isFullscreen}>
      <>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 5, right: 5, color: '#fff' }}>
          <Close />
        </IconButton>
        <Box
          sx={{
            height: '100%',
            width: '100%',
            marginTop: '0%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& .image-gallery': {
              width: '100%',
              margin: '0 auto',
            },
          }}>
          <Gallery
            items={images}
            startIndex={startIndex}
            showIndex={true}
            showBullets={true}
            showThumbnails={false}
            showPlayButton={false}
            onScreenChange={handleScreenChange}
          />
        </Box>
      </>
    </Modal>
  );
};

export default ImageGalleryModal;
